<template>
    <button :class="[variantClass]" type="button" class="btn" :disabled="loading">
        <slot></slot>
        <output v-if="loading" class="spinner-border text-light spinner-border-sm ms-2 align-middle">
            <span class="visually-hidden">Loading...</span>
        </output>
    </button>
</template>

<script>
export default {
    name: 'BButton',
    props: {
        variant: { type: String, default: 'primary' },
        loading: { type: Boolean, default: false },
    },
    data() {
        return {
            variantClass: `btn-${this.variant}`,
        };
    },
};
</script>